import React from "react";
import Category from "./Category"
import Product from "./Product";

export default function Home() {
  return <>
    <Category />
    <Product />
  </>;
}
